export default function resolveUrl(url: string) {
	return url.startsWith("/") ? `/paginas${url}` : url;
}
